import React from 'react';
import Card from '../../../components/Card';
import { TouchableOpacity, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { faClipboard, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MyAppText from '../../../components/MyAppText';
import { translate } from '../../../services/translate';
import moment from 'moment';

interface Props {
    activity: ActivityAndService;
    onEdit: () => void;
}

export default function ActivityAndServiceCard({ activity, onEdit }: Props) {
    const { styles, theme } = useStyles(styleSheet);

    return (
        <Card>
            <TouchableOpacity onPress={onEdit}>
                <View style={styles.overlineRow}>
                    <FontAwesomeIcon
                        icon={faClipboard}
                        fontSize={11}
                        color={theme.colors.neutral['400']}
                    />
                    <MyAppText style={[styles.overlineText]}>
                        {translate('activityAndServiceAcronym')}
                    </MyAppText>
                </View>
                <MyAppText style={styles.address} numberOfLines={1}>
                    {activity.address}
                    {activity.number ? `, ${activity.number}` : ''}
                </MyAppText>

                <View style={styles.timeRow}>
                    <FontAwesomeIcon icon={faClock} fontSize={14} color={theme.colors.neutral['500']} />
                    <MyAppText style={styles.timeText}>
                        {moment(activity.startDate).format('HH:mm')} – {moment(activity.endDate).format('HH:mm')}{'   '}
                        {`${activity.actionsQty} ${translate(activity.actionsQty > 1 ? 'actions' : 'action')} · ${activity.publicQty} ${translate(activity.publicQty > 1 ? 'people' : 'person')}`}
                    </MyAppText>
                </View>
            </TouchableOpacity>
        </Card>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    overlineRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
        marginBottom: 6,
    },
    overlineText: {
        fontSize: 11,
        fontWeight: '600',
        letterSpacing: 0.3,
        color: theme.colors.neutral['400'],
        textTransform: 'uppercase',
    },
    address: {
        fontSize: 14,
        fontWeight: '600',
        color: theme.colors.field.text,
        marginBottom: 6,
    },
    cep: {
        fontWeight: '400',
        color: theme.colors.neutral['400'],
    },
    timeRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
        marginBottom: 10,
    },
    timeText: {
        fontSize: 13,
        color: theme.colors.neutral['500'],
    },
}));
